import dayjs from 'dayjs';

import { User } from '@/types/Auth';
import { UserQuery } from '@/types/bff/gql-schema';
import { convertGender } from './genderConverter';
import { convertPlatform } from './platformConverter';
import { convertProvider } from './providerConverter';

const parseUserRealTime = (data: UserQuery): User => {
  const userInfo = data.user;
  return {
    id: Number(userInfo.userId),
    userId: userInfo.userId,
    email: userInfo.email ?? undefined,
    name: userInfo.detail?.name || '',
    phone: userInfo.detail?.phone || '',
    provider: convertProvider(userInfo.account.oAuthInfo?.providerType ?? undefined),
    deviceId: userInfo.deviceId || '',
    birth: userInfo.detail?.birthDate || '',
    gender: convertGender(userInfo.detail?.gender ?? undefined),
    isMarketing: userInfo.marketingReceiptAccepted,
    isNotify: userInfo.notificationAllowed,
    pushToken: userInfo.pushToken || '',
    isDoseNotify: userInfo.detail?.doseNotificationAllowed ?? false,
    isCertified: userInfo.isVerified,
    isNeedVerificationForDiagnosis: userInfo.detail?.isNeedVerificationForDiagnosis ?? false,
    createdAt: dayjs(userInfo.createdAt).toISOString(),
    platform: convertPlatform(userInfo.platform),
    username: userInfo.detail?.name || '',
    isContentNotify: userInfo.contentNotificationAllowed,
    isNightlyMarketing: userInfo.nightlyMarketingReceiptAccepted,
  };
};

export { parseUserRealTime };
